var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRapidFireBonusesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.055,
    height: 36.469,
    viewBox: "0 0 28.055 36.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-flame",
    "data-name": "Icon ionic-md-flame",
    d: "M32.807,18.637l-.018.912c-.07,1.025-.692,3.8-1.937,4.794a12.257,12.257,0,0,0,.894-7.248C30.028,8.549,23.534,4.921,15.252,3.554l-1.507-.193C17.206,7.5,18.661,10.521,18.1,13.6a10.46,10.46,0,0,1-1.227,2.77,13.466,13.466,0,0,0,.175-2.515,4.654,4.654,0,0,0-1.578-3.471,5.765,5.765,0,0,1-.8,4.181c-2.165,3.7-7.485,5.066-7.923,11.9V26.8a12.465,12.465,0,0,0,6.021,10.956,7.6,7.6,0,0,1-.5-5.276,10.14,10.14,0,0,0,2.182,4.54,6.13,6.13,0,0,0,2.9,2.182,11.571,11.571,0,0,0,4.2.631c4.891,0,8.011-1.586,10.438-4.426s2.813-5.96,2.813-9.325A13.063,13.063,0,0,0,32.807,18.637Z",
    transform: "translate(-6.75 -3.361)",
    fill: "#3d3d3d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapidFireBonusesIcon);
export default __webpack_public_path__ + "static/media/rapid-fire-bonuses-icon.75dd0ee6083ac1001864c7bed6d25a67.svg";
export { ForwardRef as ReactComponent };